import API from 'services/api';

const api = new API();

const URL_PROFILE = '/api/external-org-profile/';
const URL_PROFILE_LOGO = '/api/external-org-profile/logo/';

class ExternalOrgProfileAPI {
    getProfile() {
        return new Promise((resolve, reject) => {
            api.getJson(URL_PROFILE, {
                method: 'GET',
                credentials: 'include',
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }

    updateProfile(data) {
        return new Promise((resolve, reject) => {
            api.getJson(URL_PROFILE, {
                method: 'PATCH',
                credentials: 'include',
                body: data,
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }

    validateWebsite(website) {
        return new Promise((resolve, reject) => {
            api.getJson(`${URL_PROFILE}validate-website/`, {
                method: 'POST',
                credentials: 'include',
                body: { website },
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }

    uploadLogo(file) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('logo', file);

            api.getJson(URL_PROFILE_LOGO, {
                method: 'POST',
                credentials: 'include',
                body: formData,
                fixErr: true,
            })
                .then(response => {
                    if (response.status !== 0) return reject(response.value);
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }
}

export default new ExternalOrgProfileAPI();
